import { useDisruptionStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreDisruptionComponent } from "@b2bportal/core-types";
import { ToggleGroup } from "@tenant/ui";

import defaultStyles from "./DisruptionExerciseDateFilter.module.scss";

export interface DisruptionExerciseDateFilterProps {
  defaultSelection: "today" | "tomorrow";
  handleDateChange: (isToday: boolean) => void;
  todayTitle: string;
  tomorrowTitle: string;
}

export const DisruptionExerciseDateFilter = ({
  handleDateChange,
  todayTitle,
  tomorrowTitle,
  defaultSelection,
}: DisruptionExerciseDateFilterProps) => {
  const COMPONENT_KEY = CoreDisruptionComponent.DisruptionExerciseDateFilter;
  const styles = useDisruptionStyles(COMPONENT_KEY, defaultStyles);
  const [_, cn] = useModuleBEM(styles, COMPONENT_KEY);

  return (
    <div className={cn("disruptionButtonsDates")}>
      <ToggleGroup
        type="single"
        value={defaultSelection}
        items={[
          { id: "today", label: todayTitle },
          { id: "tomorrow", label: tomorrowTitle },
        ]}
        onValueChange={({ id }) => handleDateChange(id === "today")}
        render={(item) => (
          <div
            className={cn("button", {
              notSelected: !item.selected,
            })}
          >
            {item.item.label}
          </div>
        )}
      />
    </div>
  );
};

export default DisruptionExerciseDateFilter;
